export default {
  "languageSwitcher": {
    "label": "Idioma",
    "english": "English",
    "spanish": "Español"
  },
  "phoneInput": {
    "mobilePhoneLabel": "Teléfono Móvil",
    "countryFlagAlt": "Estados Unidos"
  },
  "select": {
    "requiredError": "Este campo es obligatorio",
    "statePlaceholder": "-- Selecciona tu estado --"
  },
  "progressBar": {
    "percentComplete": "{{percent}}% completado",
    "advertiserDisclosures": "Divulgaciones del anunciante",
    "goBack": "Regresar"
  },
  "applicationProgress": {
    "heading": "Estado de la solicitud",
    "stageOf": "Etapa {{current}} de {{total}}",
    "complete": "Completado",
    "stages": {
      "assigned": {
        "label": "Solicitud asignada",
        "description": "Tu solicitud ha sido asignada a un especialista en préstamos"
      },
      "reviewing": {
        "label": "En revisión",
        "description": "Estamos revisando tu información"
      },
      "ready": {
        "label": "Resultados listos",
        "description": "Los resultados de tu préstamo están listos"
      },
      "contact": {
        "label": "Intento de contacto",
        "description": "Nuestro equipo está intentando comunicarse contigo"
      }
    }
  },
  "footer": {
    "legalLinks": {
      "privacyPolicy": "Política de Privacidad",
      "termsOfUse": "Términos de Uso",
      "caPrivacyPolicy": "Política de Privacidad de CA",
      "optOut": "Cancelar Suscripción",
      "eCommConsent": "Consentimiento de E-Comm",
      "privacyNotice": "Aviso de Privacidad"
    },
    "logoAlt": "Symple Lending",
    "socialLabels": {
      "facebook": "Facebook",
      "x": "X",
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "tiktok": "TikTok"
    },
    "copyright": "© {{year}} Symple Lending, LLC. Todos los derechos reservados. <nmlsLink>NMLS #2508833</nmlsLink>",
    "disclosure": "Symple Lending, LLC es un prestamista con licencia de Utah bajo el Departamento de Instituciones Financieras de Utah (<nmlsLink>NMLS #2508833</nmlsLink>). Las ofertas de préstamos personales otorgadas a clientes que llegaron a través de un anuncio pagado de Google o Bing presentan tasas en Symple Lending no mayores al 35.99% APR con plazos de 61 días a 180 meses. Tu tasa real depende de tu puntaje de crédito, monto del préstamo, plazo del préstamo, domicilio y uso e historial de crédito, y se acordará entre tú y el prestamista. Un ejemplo del monto total pagado en un préstamo personal de $10,000 por un plazo de 36 meses a una tasa del 10% sería equivalente a $11,616.12 durante la vida de 36 meses del préstamo.",
    "equalHousingAlt": "Prestamista de Vivienda Equitativa",
    "partnersIntro": "Información de licencias de los <partnersLink>Socios</partnersLink> de Symple Lending:",
    "partnerAchieve": "Achieve Personal Loans (<nmls227977>NMLS #227977</nmls227977>), HELOC from Achieve Loans (<nmls1810501>NMLS # 1810501</nmls1810501>).",
    "partnerMoneyLion": "ML Enterprise Inc., también conocido como Engine by MoneyLion, (<nmls1475872>NMLS #1475872</nmls1475872>)"
  },
  "disclaimer": {
    "consent": "Todas las interacciones en el sitio web y las llamadas telefónicas se graban para fines de marketing, cumplimiento y control de calidad. Al hacer clic en el botón anterior o al usar este sitio web, aceptas nuestros <termsLink>Términos y Condiciones</termsLink>, <esignLink>Firma Electrónica</esignLink>, <arbitrationLink>Acuerdo de Arbitraje</arbitrationLink> y <privacyLink>Política de Privacidad</privacyLink>, incluidas las disposiciones sobre la aceptación o el rechazo de cookies."
  },
  "disclosureModal": {
    "title": "Divulgaciones del Anunciante",
    "closeLabel": "Cerrar",
    "paragraph1": "Symple Lending no es un prestamista y no ofrecemos productos financieros directamente. Symple Lending no representa a los Proveedores de Instituciones Financieras de nuestra plataforma, salvo como fuente de referencia, y no respalda ni recomienda proveedores o productos financieros en particular. Symple Lending no acepta solicitudes, no toma decisiones de crédito ni garantiza un resultado particular de una solicitud de oferta de producto financiero. Cualquier Proveedor de Institución Financiera requerirá que le envíes una solicitud para su consideración antes de extender una oferta de crédito. No emitimos aprobaciones de préstamos, compromisos de préstamo, ni hacemos garantías en nombre de ningún Proveedor de Institución Financiera, y todas las tasas, cargos y condiciones se presentan sin garantía. Las tasas, cargos y condiciones están sujetos a cambios según el criterio de cada Proveedor de Institución Financiera y pueden no estar disponibles en todos los estados o para todos los tipos de productos financieros. Es posible que recibas ofertas de préstamo que varíen en monto respecto a lo solicitado. También podemos mostrar ofertas de productos financieros distintos al tipo solicitado, como alivio de deudas, liquidación de deudas, reparación de crédito o monitoreo de crédito. Las políticas de privacidad o prácticas de seguridad de los Proveedores de Instituciones Financieras pueden diferir de las de Symple Lending.",
    "paragraph2": "No te conectamos con todos los Proveedores de Instituciones Financieras del mercado, por lo que otras instituciones financieras y productos financieros no incluidos en nuestra plataforma pueden estar disponibles para ti, sujetos a diferentes términos y condiciones, incluidas tasas más bajas. No podemos garantizar el precio más bajo ni las mejores condiciones disponibles en el mercado. Tu situación financiera personal es única, y es tu responsabilidad evaluar la información y el contenido proporcionado antes de tomar cualquier decisión financiera.",
    "paragraph3": "Apoyamos los principios de la Ley Federal de Igualdad de Oportunidades de Crédito (\"ECOA\", por sus siglas en inglés). No participamos en prácticas comerciales que discriminen por motivos de raza, color, religión, origen nacional, sexo, estado civil, edad (siempre que el solicitante tenga capacidad para contratar), el hecho de que la totalidad o parte de los ingresos del solicitante provenga de un programa de asistencia pública, o el hecho de que el solicitante haya ejercido de buena fe algún derecho conforme a la Ley de Protección al Crédito del Consumidor. De igual manera, estamos comprometidos con el cumplimiento de las leyes estatales y locales antidiscriminación que resulten aplicables."
  },
  "emailVerificationModal": {
    "title": "Verifica Tu Correo Electrónico",
    "description": "Necesitamos tu dirección de correo electrónico para completar tu solicitud.",
    "submit": "Continuar con este correo",
    "submitting": "Enviando..."
  },
  "loadingOverlay": {
    "processing": "Procesando..."
  },
  "echelonProgress": {
    "title": "Procesando tu solicitud",
    "subtitle": "Esto puede tardar 1–2 minutos. Por favor, mantén esta página abierta.",
    "done": "Hecho",
    "steps": {
      "starting": {
        "label": "Verificando tu elegibilidad",
        "description": "Revisando tus datos según nuestros criterios"
      },
      "processing": {
        "label": "Conectando con especialistas en soluciones",
        "description": "Tu solicitud está siendo asignada a nuestro equipo"
      },
      "reviewing": {
        "label": "Revisando tu solicitud",
        "description": "Analizando tu perfil y las opciones disponibles"
      },
      "finalizing": {
        "label": "Preparando tus opciones personalizadas",
        "description": "Ya casi está — compilando tus resultados"
      }
    }
  },
  "button": {
    "loadingDefault": "Cargando..."
  },
  "securityTiles": {
    "sslTitle": "SSL de 256 bits",
    "sslDescription": "Seguro y Encriptado",
    "privacyTitle": "Privacidad Primero",
    "privacyDescription": "Tus Datos Están Protegidos",
    "speedTitle": "Rápido y Fácil",
    "speedDescription": "Solicitud de 2 Minutos"
  },
  "tryAnotherWay": {
    "prompt": "Prueba un método de verificación diferente:",
    "smsCode": "Verificar con Código SMS",
    "securityQuestions": "Verificar con Preguntas de Seguridad",
    "offerCode": "Verificar con Código de Oferta"
  },
  "applicationFlow": {
    "loading": {
      "offers": "Cargando tus ofertas...",
      "personalizedDetails": "Cargando tus detalles personalizados...",
      "application": "Cargando tu solicitud...",
      "secureConnection": "Creando conexión segura...",
      "verifyingSmsCode": "Verificando código SMS...",
      "checkingEligibility": "Verificando elegibilidad...",
      "sendingNewCode": "Enviando nuevo código...",
      "verifyingInformation": "Verificando tu información...",
      "verifyingIdentity": "Verificando tu identidad...",
      "submittingAnswers": "Enviando tus respuestas...",
      "submittingApplication": "Enviando solicitud..."
    },
    "errors": {
      "genericError": "Ocurrió un error",
      "failedToCreateConnection": "No se pudo crear la conexión",
      "noSecurityQuestions": "No se recibieron preguntas de seguridad",
      "failedToStartIdentityVerification": "No se pudo iniciar la verificación de identidad",
      "identityVerificationFailed": "La verificación de identidad falló",
      "unableToVerifyIdentity": "No pudimos verificar tu identidad. Por favor, intenta un método diferente.",
      "verificationFailedCheckDetails": "La verificación falló. Por favor, revisa tus datos e intenta de nuevo.",
      "failedToSendNewCode": "No se pudo enviar el nuevo código",
      "failedToConnectCall": "No se pudo conectar la llamada. Por favor, intenta de nuevo.",
      "sessionExpired": "Tu sesión ha expirado o no pudo continuar. Por favor, comienza de nuevo."
    }
  },
  "phoneDialer": {
    "outsideHoursTitle": "Fuera del Horario de Llamadas",
    "outsideHoursDescription": "Debido a las regulaciones de TCPA, solo podemos llamar entre las 8 AM y las 8 PM hora local.",
    "nextAvailableTime": "Próximo horario disponible: {{time}}",
    "callErrorTitle": "Ocurrió un error al conectar tu llamada.",
    "callErrorSubtitle": "Llámanos directamente usando el número de abajo",
    "callMeNow": "Llámame Ahora",
    "callUnableToConnect": "No se pudo conectar tu llamada. Usa el número de abajo para llamarnos directamente.",
    "callConnectionFailed": "La conexión falló. Usa el número de abajo para llamarnos directamente.",
    "callAutoConnectFailed": "No se pudo conectar automáticamente. Usa el número de abajo para llamarnos directamente.",
    "connectingTitle": "Conectando Tu Llamada",
    "connectingSubtitle": "Para hablar sobre tu solicitud de préstamo",
    "secondsLabel": "segundos",
    "incomingCallFrom": "Llamada entrante de:"
  }
} as const;
